import React from "react";
import Input from "./Input";
import Select from "./Select";
import RadioButtons from "./RadioButtons";

function FormikControl(props) {
  const { control, ...rest } = props;
  switch (control) {
    case "input":
      return <Input {...rest} />;
    case "select":
      return <Select {...rest} />;
    case "radio":
      return <RadioButtons {...rest} />;
    default:
      return null;
  }
}

export default FormikControl;
